import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {HelpInfo} from '../../../models/help-info.interface';
import {MatSort} from '@angular/material/sort';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {appConfig} from '../../../../config/config';
import {MatDialog} from '@angular/material/dialog';
import {EditDialogComponent} from '../edit-dialog/edit-dialog.component';

@Component({
  selector: 'app-dialogs-table',
  templateUrl: './dialogs-table.component.html',
  styleUrls: ['./dialogs-table.component.scss']
})
export class DialogsTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['id', 'code', 'title', 'edit'];

  @Input()
  dialogs!: HelpInfo[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadDialogs: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadDialogs.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadDialogs.emit({page: event.pageIndex, size: event.pageSize});
  }

  editDialog(value: HelpInfo): void {
    const dialogRef = this.dialog.open(EditDialogComponent, { data: value, maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.updateEvent.subscribe(() => {
      this.loadDialogs.emit({page: this.paginator.pageIndex, size: this.paginator.pageSize});
    });
  }

}
